<div class="change-password-wrapper">
	<div class="row head page-container">
		<h2 class="heading">CHANGE PASSWORD</h2>
		<div class="button-group-wrapper">
			<button class="curved cancel">CANCEL</button>
			<button class="curved button-lg">SAVE</button>
		</div>
	</div>
	<div class="page-container">
		<div class="row">
			<div class="col-md-4">
				<div class="row">
					<h4 class="heading">SECURITY</h4>
					<mat-form-field class="form-group">
						<mat-label>Current Password</mat-label>
						<input matInput type="password" />
					</mat-form-field>
				</div>
				<div class="row">
					<mat-form-field class="form-group">
						<mat-label>New Password</mat-label>
						<input matInput type="password" />
					</mat-form-field>
				</div>
				<div class="row">
					<mat-form-field class="form-group">
						<mat-label>Confirm New Password</mat-label>
						<input matInput type="password" />
					</mat-form-field>
				</div>
			</div>
		</div>
	</div>
</div>
